import GATSBY_COMPILED_MDX from "/opt/build/repo/new-work/content/posts/16_augen-der-eule.mdx";
import React from 'react';
import {graphql} from 'gatsby';
import {GatsbyImage, getImage, getSrc} from 'gatsby-plugin-image';
import Meta from './Meta';
import App from './App';
import StickyHeader from './StickyHeader';
import SkipToContent from './SkipToContent';
import PostHeader from './PostHeader';
import {Bylines} from './Bylines';
import {PostList} from './PostList';
import PostBody from './PostBody';
import PostHeaderVideo from './PostHeaderVideo';
import SearchForm from './SearchForm';
import FallbackIllustration from './FallbackIllustration';
import * as styles from './Post.module.scss';
export const query = graphql`
  query ($id: String!) {
    site: site {
      siteMetadata {
        title
      }
    }
    post: file(id: { eq: $id }) {
      id
      childMdx {
        fields {
          slug
        }
        frontmatter {
          title
          short_title
          intro
          order
          category
          hero_alt
          hero_portrait_alt
          hero_credits {
            label
            name
          }
          hide_body
          hero_image {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, breakpoints: [750, 1080, 1366, 1920, 2500])
            }
          }
          hero_video
          hero_portrait {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, placeholder: NONE, width: 500)
            }
          }
          authors {
            frontmatter {
              name
              author_id
              institution
              role
            }
            parent {
              ... on Mdx {
                body
              }
            }
          }
        }
      }
    }
    posts: allFile(filter: { extension: { eq: "mdx" }, sourceInstanceName: { eq: "posts" } }, sort: { childMdx: { frontmatter: { order: ASC } } }) {
      nodes {
        id
        childMdx {
          fields {
            slug
          }
          frontmatter {
            title
            short_title
            order
            intro
            title_prefix
            category
            format
            published_on
            authors {
              frontmatter {
                name
              }
            }
          }
        }
      }
    }
  }
`;
const Post = ({data, children}) => {
  const frontmatter = data.post.childMdx.frontmatter;
  let heroImage = null;
  if (frontmatter.hero_image) {
    heroImage = React.createElement(GatsbyImage, {
      className: styles.heroImage,
      loading: "eager",
      image: getImage(frontmatter.hero_image),
      alt: frontmatter.hero_alt
    });
  } else {
    heroImage = React.createElement(FallbackIllustration, {
      category: frontmatter.category
    });
  }
  let portraitImage = null;
  if (frontmatter.hero_portrait) {
    portraitImage = React.createElement(GatsbyImage, {
      className: styles.heroPortrait,
      loading: "eager",
      image: getImage(frontmatter.hero_portrait),
      alt: frontmatter.hero_portrait_alt
    });
  }
  const videoEl = frontmatter.hero_video ? React.createElement(PostHeaderVideo, {
    src: frontmatter.hero_video,
    poster: heroImage
  }) : null;
  return React.createElement(App, {
    className: `${frontmatter.category}`
  }, React.createElement(SkipToContent), React.createElement(StickyHeader, {
    searchForm: React.createElement(SearchForm),
    post: data.post
  }), React.createElement("article", {
    id: "content",
    className: `${styles.container}`
  }, React.createElement(PostHeader, {
    title: frontmatter.title,
    media: videoEl ? videoEl : heroImage,
    portrait: portraitImage,
    intro: frontmatter.intro,
    credits: frontmatter.hero_credits,
    hasIllustration: frontmatter.hero_image != null
  }), React.createElement("main", {
    className: styles.body
  }, !frontmatter.hide_body && React.createElement(React.Fragment, null, frontmatter.authors && React.createElement("aside", {
    className: styles.credits
  }, React.createElement(Bylines, {
    authors: frontmatter.authors
  })), React.createElement("div", {
    className: styles.copy
  }, React.createElement(PostBody, null, children))), React.createElement("nav", {
    className: styles.postsNav
  }, React.createElement(PostList, {
    posts: data.posts.nodes,
    currentPostId: data.post.id
  })))));
};
export function Head({data}) {
  const frontmatter = data.post.childMdx.frontmatter;
  return React.createElement(Meta, {
    title: `${frontmatter.title} – ${data.site.siteMetadata.title}`,
    description: frontmatter.intro,
    image: {
      src: getSrc(frontmatter.hero_image),
      alt: frontmatter.hero_alt
    }
  });
}
Post
export default function GatsbyMDXWrapper(props) {
  return React.createElement(Post, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
